import Axios from '@/axios';

// 查询某机构的所有下级机构数组
export const getSubOrgs = params => {  
  return Axios({
    url: '/face/web/departments/index_children',
    method: 'GET',
    type: 'json',
    params
  })
}
// 查询机构树
export const getOrgTree = params => {  
  return Axios({
    url: '/face/web/departments/show_tree',
    method: 'GET',
    type: 'json',
    params
  })
}
// 创建机构
export const createOrg = data => {  
  return Axios({
    url: '/face/web/departments/create_dept',
    method: 'POST',
    type: 'json',
    data
  })
}
// 修改机构
export const modifyOrg = data => {  
  return Axios({
    url: '/face/web/departments/update_dept',
    method: 'POST',
    type: 'json',
    data
  })
}
// 删除机构
export const deleteOrg = data => {
  return Axios({
    url: '/face/web/departments/delete_dept/' + data.id,
    method: 'POST',
    type: 'json'
  })
}